import { LazyImage } from '@components/common/image'
import ProjectCard from './project-card'

const IMAGE_PATH = '/images/school-partnership/projects/'

type ProjectDataType = {
  title: string
  description: string
  imageName: string
}

const PROJECT_CARD_DATA: ProjectDataType[] = [
  {
    title: 'Electric current flow animation',
    description:
      'Our student wrote the code for an animation depicting the flow of an electric current',
    imageName: 'electric-current',
  },
  {
    title: 'Fruit Ninja Game',
    description:
      "Our student wrote the code for building his own version of the game 'Fruit Ninja'.",
    imageName: 'fruit-ninja',
  },
  {
    title: '7 wonders of the world animation',
    description:
      'Our student wrote the code for an animation that takes you around the world to visit the 7 wonders.',
    imageName: 'wonders-of-the-world',
  },
  {
    title: 'Story animation',
    description:
      'Our student wrote the code for an animation that presents a wonderful story!',
    imageName: 'story',
  },
  {
    title: 'Move with arrows',
    description:
      'Check out the game our student made to help his sprite move to get his chores done.',
    imageName: 'move-with-arrows',
  },
  {
    title: 'Flying Bee',
    description:
      'Our student wrote the code for an animation that helps the bee fly from flower to flower collecting nectar.',
    imageName: 'flying-bee',
  },
]

const Projects = () => {
  return (
    <div className="py-10 lg:pt-10 lg:pb-20 flex flex-col max-w-6xl mx-auto relative items-center bg-blue-50 bg-opacity-25 lg:bg-white">
      <LazyImage
        path={IMAGE_PATH}
        name="left-shapes"
        className="hidden lg:flex absolute top-5 left-0 z-10"
        alt="Background left shapes"
      />
      <LazyImage
        path={IMAGE_PATH}
        name="right-shapes"
        className="hidden lg:flex absolute top-10 right-0 z-10"
        alt="Background right shapes"
      />
      <div className="text-center px-5 pb-3">
        <h1 className="font-700 text-4xl leading-tight text-grey lg:max-w-md lg:mx-auto">
          We are proud to support creators of the future
        </h1>
        <h4 className="text-3xl font-600 lg:text-2xl leading-tight text-grey-800 py-5">
          Our kids have made wonderful creations of their own
        </h4>
      </div>

      <div className="flex flex-row flex-wrap justify-center lg:bg-blue-50 lg:bg-opacity-50 rounded-2xl lg:py-10 md:px-5 lg:pb-16">
        {PROJECT_CARD_DATA.map((card, index) => (
          <ProjectCard
            key={index}
            title={card.title}
            description={card.description}
            imagePath={IMAGE_PATH}
            imageName={card.imageName}
            alt={card.title}
          />
        ))}
      </div>
    </div>
  )
}

export default Projects
